var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.posts
    ? _c(
        "ul",
        _vm._l(_vm.posts, function (post) {
          return _c(
            "li",
            { key: post.postId },
            [
              _c("DrillPostListItem", {
                attrs: { post: post, "mastered-post-ids": _vm.masteredPostIds },
              }),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }